<template>
  <div class="gestionale">
    <div class ="permesso" v-for="permesso in permessi" :class="permesso.class" @click="goTo" :id="permesso.event" :key="permesso.id">{{ $t(permesso.event) }}</div>
  </div>
</template>


<script>
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'Gestionale',
  data: function () {
    return {
        permessi:[],
        store
    }
},
  methods: {
    displayUser () {
      // inserisco i permessi dell'utente 
      this.axios.post(this.store.path+'displayUser',{nome:JSON.parse(localStorage.nome),headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
           if(response.data.messaggio){
                 response.data.messaggio.forEach(element => {
                   if(element.event) {
                     this.permessi.push(element)
                   }
                  
            });
            this.permessi = this.permessi.sort((a,b) => (a.event > b.event) ? 1 : ((b.event> a.event) ? -1 : 0))
            }else{console.log('Non ci sono permessi da mostrare')}

        })
    },
    goTo(e){
      this[e.target.id]()
    },
    editMenu(){
      this.$router.push({ name: "EditMenu"})

    },
    mappaturaP() {
      this.$router.push({ name: "MappaturaP"})
    },
    tabellaProdotti() {
      this.$router.push({ name: "TabellaProdotti"})
    },
    magazzino() {
      this.$router.push({ name: "Magazzino"})
    },
    mappaturaPiatti() {
      this.$router.push({ name: "MappaturaPiatti"})
    },
    ordina() {
      this.$router.push({ name: "Ordina"})
    },
    carica() {
      this.$router.push({ name: "Carica"})
    },
    analisiCosti() { 
      this.$router.push({ name: "analisiCosti"})
    },
    riepilogoAndamento() { 
      this.$router.push({ name: "riepilogoAndamento"})
    },
    aggiunte() { 
      this.$router.push({ name: "aggiunte"})
    },
    stampaPrenotati() {
      this.$router.push({ name: "stampaPrenotati"})
    },
    gestioneCredenziali() {
      this.$router.push({ name: "GestioneCredenziali"})
    },
      changelayout() {
      this.$router.push({ name: "ChangeLayout"})
    },
    gestioneAsporto() {
      this.$router.push({ name: "GestioneAsporto"})
    },
    stampanti () {
      this.$router.push({ name: "Stampanti"})
    },
    gestioneFatture() {
      this.$router.push({ name: "InvoiceManager"})
    },
    gestioneSocial() {
      this.$router.push({ name: "Social"})
    },
    "report-ai"() {
      this.$router.push({ name: "ReportAI"})
    },
    traduci() {
      this.$router.push({ name: "Traduci"})
    },
    allergeni() {
      this.$router.push({ name: "Allergeni"})
    },
    digitalizzazione() {
      this.$router.push({ name: "Digitalizzazione"})
    },
    tempiDiAttesa() {
      this.$router.push({ name: "TempiDiAttesa"})
    },
    prenotazioniSetting() {
      this.$router.push({ name: "PrenotazioniSetting"})
    },
    marcia() {
      this.$router.push({ name: "Marcia"})
    },
    cameriere() {
      this.$router.push({ name: "ChiamateCameriere"})
    },
    settings() {
      this.$router.push({ name: "Impostazioni"})
    },
    impostazioni() {
      this.$router.push({ name: "Impostazioni"})
    },
    riepilogo() {
      this.$router.push({ name: "RiepilogoOrdini" })
    },
    statistiche() {
      this.$router.push({ name: "Statistiche" })
    },
    "documenti-fiscali"() {
      this.$router.push({ name: "DocumentiFiscali" })
    },
    "pagamenti"() {
      this.$router.push({ name: "Pagamenti" })
    }
  },
  beforeMount () {
    this.displayUser()
  }
  
}
</script>

<style scoped>

.gestionale {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 25px;
  padding: 30px 15px;
  min-height: 80vh;
  box-sizing: border-box;
}

.permesso {
  flex: 0 1 270px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  padding: 15px;
  border-radius: 15px;
  background: #e0e0e0;
  box-shadow: -10px 10px 20px #bebebe, 10px -10px 20px #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: bold;
  text-align: center;
  color: #333;
}

.permesso:hover {
  transform: translateY(-5px);
  box-shadow: -15px 15px 30px #bebebe, 15px -15px 30px #ffffff;
  background: #e8e8e8;
}

.permesso:active {
  transform: scale(0.95);
  box-shadow: inset -5px 5px 10px #bebebe, inset 5px -5px 10px #ffffff;
}

@media (max-width: 600px) {
    .gestionale {
        gap: 15px;
        padding: 20px 10px;
    }
    .permesso {
        flex: 1 1 140px;
        min-height: 80px;
        font-size: 0.9rem;
        padding: 10px;
    }
}
</style>